import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useLocation, useNavigate } from "react-router-dom";
import dateFormat from "dateformat";
import { baseURL, vapidKey } from "../../constants/Api.js";
import BottonToggle from "../bars/BottomToggle.js";
import EnterName from "../../components/EnterName.js";
import EnterBookinngModal from "../../components/EnterBookinngModal.js";
import Welcome from "../../components/skeletons/WelcomeSkeleton.js";
import Skeleton from "../../components/skeletons/skeleton.js";
import WelcomeImg from "../../images/welcome.png";
import LocationImg from "../../images/place.svg";
import { useDispatch, useSelector } from "react-redux";
import { setAppUserId } from "../../slices/LayoutSlice.js";
import { fetchEventLink } from "../../utils/util.js";
import { getToken } from "firebase/messaging";
import { messaging } from "../login/firebase/Firebase.js";
import { HotelBookingsPageView } from '../../utils/Analytics.js';


function HotelList(props) {
  const [allData, setallData] = useState([]);
  const [NoBooking, setNoBooking] = useState(false);
  const [bookingData, setBookingData] = useState([]);
  const navigate = useNavigate();
  const [hasName, setHasName] = useState(false);
  const appUserName = localStorage.getItem("appUserName");
  const mobileNumber = localStorage.getItem("phone_no");
  const email = localStorage.getItem("guest_email");
  const [enterBooking, setEnterBooking] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loader, setLoader] = useState(false);
  const restrictHotelList = localStorage.getItem("restrictHotelListFlag");
  const eventRedirectLink = useSelector((store) => store?.layout?.eventRedirect);
  const location = useLocation();
  const appUserIdFromStore = useSelector((store) => store.layout.appUserId);
  const [deviceToken, setDeviceToken] = useState(localStorage.getItem('firebaseDeviceToken')?? "");
  const eventLinkLocal =fetchEventLink()
  const dispatch = useDispatch()
  const getBookingId = async (name) => {
    let data;
    console.log("entered")
    if (mobileNumber !== null) {
      data = JSON.stringify({
        mobileOrEmail: mobileNumber,
        type: "mobile",
        name: appUserName ? appUserName : name,
      });
    } else {
      data = JSON.stringify({
        mobileOrEmail: email,
        type: "email",
        name: appUserName ? appUserName : name,
        deviceId: generateDeviceId(),
        deviceToken: deviceToken ?? "",
      });
    }

    let config = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${baseURL}/api/getBookingIdV21`,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      data: data,
    };
    setLoading(true);
    try {
      const response = await axios.request(config);
      console.log(response?.data?.data?.appUserId)
      if(response?.data?.data){
        dispatch(setAppUserId(response?.data?.data?.appUserId))
        console.log(eventRedirectLink, location?.state?.source)
       
        localStorage.setItem("appUserId",response?.data?.data?.appUserId)
      }
      if (response.data.success) {
        setallData(response.data.data.bookingDetails);
        console.log(response)
        setLoading(false);
      } else {
        setNoBooking(true);
        setLoading(false);
      }
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    let storedBookingData = JSON.parse(localStorage.getItem("BookingIDDetailsArray")) || [];
    const currentDate = new Date().toISOString().split("T")[0]; 
    const storedBookingDatas = storedBookingData.filter(item => {
      const itemDateOut = item.reservationDetails.dateOut.split(" ")[0];
      return itemDateOut >= currentDate;
    });
    setBookingData(storedBookingDatas);
  }, []);

  const getData = () => {
    var name = localStorage.getItem("appUserName");
    console.log("ewee",eventRedirectLink)

    setHasName(true);
    getBookingId(name);
    console.log(eventRedirectLink)
   
  };

  const generateToken = async () => {
    // const prefix = "WEBTOKEN";
    // const currentTime = new Date().getTime().toString().slice(-11);
    // const uniqueID = prefix + currentTime;
    // return uniqueID;

    const token = await getToken(messaging, {
      vapidKey: vapidKey
    }); 
    // return token;
    localStorage.setItem('firebaseDeviceToken',token)
    setDeviceToken(token);
  };
  const generateDeviceId = () => {
    const prefix = "WEBID";
    const currentTime = new Date().getTime().toString().slice(-11);
    const uniqueID = prefix + currentTime;
    return uniqueID;
  };

 

  const redirect = () => {
    if (
      localStorage.getItem("phone_no") === null &&
      localStorage.getItem("guest_email") === null
    ) {
      navigate("../login");
    } else if (restrictHotelList) {
      navigate("../home");
    }
  };

  useEffect(() => {
    HotelBookingsPageView();
    redirect();
    localStorage.removeItem("checkout");
    if (localStorage.getItem("appUserName")) {
      setHasName(true);
   
      getBookingId()
  
    } else {
      setHasName(false);
    }
  }, [deviceToken]);

  useEffect(()=>{
   generateToken();
  },[]);

  useEffect(()=>{
    console.log((eventRedirectLink , location?.state?.source , eventLinkLocal))
    if(appUserIdFromStore){          setLoading(true);

        if(eventLinkLocal){

          // navigate(eventRedirectLink || location?.state?.source || eventLinkLocal);
          window.location.href = eventLinkLocal
        }else{
        setLoading(false);
        }}
  },[appUserIdFromStore])

  const dateConverter = (param) => {
    let inputDate = new Date(param);
    let currentDate = new Date();

    // Check if input date is today
    if (
      inputDate.getDate() === currentDate.getDate() &&
      inputDate.getMonth() === currentDate.getMonth() &&
      inputDate.getFullYear() === currentDate.getFullYear()
    ) {
      return "Today";
    } else {
      // Check if input date is tomorrow
      let tomorrow = new Date();
      tomorrow.setDate(currentDate.getDate() + 1);

      if (
        inputDate.getDate() === tomorrow.getDate() &&
        inputDate.getMonth() === tomorrow.getMonth() &&
        inputDate.getFullYear() === tomorrow.getFullYear()
      ) {
        return "Tomorrow";
      }
    }
  };


  const submitBooking = async (bookingId) => {
    let data;
    const hotelId = bookingId;
    if (hotelId) {
      if (mobileNumber) {
        data = { bookingId: hotelId, mobileNumber };
      } else if (email) {
        data = { bookingId: hotelId, email };
      }
      try {
        setLoader(true);
        const response = await axios.post(`${baseURL}/api/bookingIdV21`, data, {
          headers: { "Content-Type": "application/json" },
        });
  
        if (response.data.success) {
          setLoader(false);
          navigate("../home", {
            state: {
              data: response?.data.data,
            },
          });
        } else {
          setLoader(false);
          localStorage.removeItem("restrictHotelListFlag");
        }
      } catch (error) {
        setLoader(false);
        console.error("Error submitting booking ID:", error);
      }
    }
  };

  return (
    <div>
      <BottonToggle EnterName={hasName}/>
      <div className="flex w-full pt-10 sm:h-40 h-32 bg-[#171538] relative">
        <div className="absolute bottom-0  left-1/2 -translate-x-1/2">
          <img className="sm:h-40" src={WelcomeImg} alt="" />
        </div>
      </div>
    {!loading && !loader ? (
        <div className="section-wrap">
          <div className="mt-4">
            {hasName ? (
              <div className="pb-[90px]">
                <div className="guestName   text-left">
                  <span className="mr-1">Hi</span> {appUserName}
                </div>
                {NoBooking ? (
                  <div className="bookP   text-left pt-3">
                    You have no active booking now
                    <br />
                    Please enter the hotel booking Id for services.
                  </div>
                ) : (
                  <div className="bookP  text-left pt-3">
                    You have active bookings <br />
                    Please click the hotel for services.
                  </div>
                )}

                {!NoBooking && (
                  <div className="mt-8 gap-6 grid grid-flow-row grid-cols-1">
                    {allData.map((HotelData, index) => (
                      <button
                      onClick={() => submitBooking(HotelData.bookingId)}
                        className="homeBox rounded-md overflow-hidden"
                        key={index}>
                        <div className="p-3">
                          {(dateConverter(HotelData.dateIn) === "Today" ||
                            dateConverter(HotelData.dateIn) === "Tomorrow") && (
                            <div className="flex items-center space-x-2">
                              <div className="w-3 h-3 rounded-full flex justify-center items-center bg-[#C7FFE4] relative">
                                <div className="w-1 h-1 rounded-full bg-[#16C270] animate-ping"></div>
                              </div>
                              <div className="text-[11px] font-medium text-[#FFF]">
                                Check-in :
                                <span className="font-semibold ml-2">
                                  {dateConverter(HotelData.dateIn)}
                                </span>
                              </div>
                            </div>
                          )}
                          <div className="flex space-x-4">
                            <div className="w-[44px] h-[44px] mt-3 bg-gray-300 rounded-md shrink-0">
                              {HotelData.logo !== "" && (
                                <img
                                  src={HotelData.logo}
                                  className="w-full h-full rounded"
                                  alt=""/>
                              )}
                            </div>
                            <div className="flex-col mt-2">
                              <div className="flex text-[#E2E2E2] text-[15px] font-semi-bold">
                                {HotelData.hotel} <span className="pl-1 text-[#B8B8B8]">({HotelData.bookingId})</span>
                              </div>
                              {HotelData.city && (
                                <div className="flex items-center space-x-1 pt-1">
                                  <img src={LocationImg} alt="" />
                                  <div className="flex text-[#B8B8B8] text-[13px] font-medium">
                                    {HotelData.city}, {HotelData.country}
                                  </div>
                                </div>
                              )}
                              <div className="w-full mt-1 font-semibold text-[13px] text-[#E2E2E2]">
                                <span>
                                  {dateFormat(HotelData.dateIn, "dd-mmm-yy")}
                                </span>
                                <span className="mx-2">-</span>
                                <span>
                                  {dateFormat(HotelData.dateOut, "dd-mmm-yy")}
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="bg-[#F6FED7] w-full flex justify-end">
                          <div className="text-[9px] font-medium text-[#272727] px-3 py-2">
                            See Details
                          </div>
                        </div>
                      </button>
                    ))}
                  </div>
                )}
                <div className="mt-10 flex flex-col justify-center   items-center text-center">
                  {!NoBooking && (
                    <div className="mb-3 text-sm font-light text-gray-400">
                      Or with
                    </div>
                  )}
                  <button
                    onClick={() => setEnterBooking(true)}
                    className="enter-booking w-full">
                    Booking Id
                  </button>
                  {enterBooking && (
                    <EnterBookinngModal hide={() => setEnterBooking(false)} />
                  )}
                </div>
                {bookingData.length > 0 && (
                  <div className="bookP text-left pt-3">Previously Entered Booking Id</div>
                )}
               {bookingData.filter(HotelData => !allData.some(data => data.bookingId === HotelData.reservationDetails.bookingId)).map(HotelData => (
                <div key={HotelData.bookingId}>
                <div className="mt-5 gap-6 grid grid-flow-row grid-cols-1">
                <button
                  onClick={() => submitBooking(HotelData.reservationDetails.bookingId)}
                  className="homeBox rounded-md overflow-hidden">
                  <div className="p-3">
                    <div className="flex space-x-4">
                    <div className="w-[44px] h-[44px] mt-3 bg-gray-300 rounded-md shrink-0">
                        {HotelData.hoteldetails?.logo && (
                          <img
                            src={HotelData.hoteldetails.logo}
                            className="w-full h-full rounded"
                            alt="Hotel Logo"/>
                        )}
                      </div>
                      <div className="flex-col mt-2">
                        <div className="flex text-[#E2E2E2] text-[15px] font-semi-bold">
                          {HotelData.hoteldetails?.hotelName}<span className="pl-1 text-[#B8B8B8]">({HotelData.reservationDetails?.bookingId})</span>
                        </div>
                        {HotelData.hoteldetails?.city && (
                          <div className="flex items-center space-x-1 pt-1">
                            <img src={LocationImg} alt="Location Icon" />
                            <div className="flex text-[#B8B8B8] text-[13px] font-medium">
                              {HotelData.hoteldetails.city}, {HotelData.hoteldetails.country}
                            </div>
                          </div>
                        )}
                        <div className="w-full mt-1 font-semibold text-[13px] text-[#E2E2E2]">
                          <span>{dateFormat(HotelData.reservationDetails?.dateIn, "dd-mmm-yy")}</span>
                          <span className="mx-2">-</span>
                          <span>{dateFormat(HotelData.reservationDetails?.dateOut, "dd-mmm-yy")}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="bg-[#F6FED7] w-full flex justify-end">
                    <div className="text-[9px] font-medium text-[#272727] px-3 py-2">
                      See Details
                    </div>
                  </div>
                </button>
              </div>
            </div>
          ))}
            </div>
            ) : (
              <EnterName hide={(appUserId) => getData(appUserId)} />
            )}
          </div>
        </div>
      ) : (
        loading ? <Welcome /> : loader ? <Skeleton type="page" /> : null
      )}
    </div>
  );
}

export default HotelList;
